import React from 'react';
import MenuItem from 'material-ui/Menu/MenuItem';

export default class AutoCompleteOption extends React.Component {
  handleClick = (event) => {
    this.props.onSelect(this.props.option, event);
  };

  render() {
    const { children, isFocused, isSelected, onFocus } = this.props;

    return (
      <MenuItem
        onFocus={onFocus}
        selected={isFocused}
        onClick={this.handleClick}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
        }}
      >
        {children}
      </MenuItem>
    );
  }
}




// WEBPACK FOOTER //
// ./src/helpers/AutoCompleteOption.js